// extracted by mini-css-extract-plugin
export var animationAbsolute = "_20-q";
export var animationRelative = "_20-p";
export var backdropBlur = "_20-0";
export var detailLabelCell = "_20-12";
export var detailTable = "_20-11";
export var detailValueCell = "_20-13";
export var docIconBox = "_20-1d";
export var docIconBoxMd = "_20-1f";
export var docIconBoxSm = "_20-1e";
export var docTypeRow = "_20-16";
export var docTypeRowInner = "_20-17";
export var dropdownMatchDatePicker = "_20-3";
export var evidenceCardContent = "_20-1c";
export var fileUploadSpin = "_20-j";
export var gorgiasOpenButton = "_20-15 _20-d";
export var gorgiasTicketCard = "_20-14";
export var heroModalFooterButton = "_20-18";
export var hiddenContainer = "_20-o";
export var iconPrimary = "_20-1g";
export var iconQuaternary = "_20-1i";
export var iconTertiary = "_20-1h";
export var integrationCard = "_20-1";
export var integrationLogoBox = "_20-2";
export var mainColumnSticky = "_20-1b";
export var maxWidthContainer = "_20-19";
export var modalContentBody = "_20-a";
export var modalHeaderImage = "_20-5";
export var modalImageLabel = "_20-7";
export var modalImageOverlay = "_20-6";
export var modalImageSubtitle = "_20-9";
export var modalImageTitle = "_20-8";
export var modalImageWrapper = "_20-4";
export var modalStickyFooter = "_20-b";
export var removeButton = "_20-e";
export var sidebarColumn = "_20-1a";
export var spinner = "_20-i";
export var timelineLine = "_20-y";
export var timelineLineBlack = "_20-10 _20-y";
export var timelineLineGray = "_20-z _20-y";
export var timelineLineHeight = "_20-x";
export var tlDotActivate = "_20-u";
export var tlDotActivateAnim = "_20-t";
export var tlDotHide = "_20-s";
export var tlDotHideAnim = "_20-r";
export var tlLineActivate = "_20-w";
export var tlLineActivateAnim = "_20-v";
export var uploadHint = "_20-n";
export var uploadIconBox = "_20-k";
export var uploadLabel = "_20-m";
export var uploadText = "_20-l";
export var uploadZone = "_20-f";
export var uploadZoneCursorDefault = "_20-h";
export var uploadZoneCursorPointer = "_20-g";
export var uploadedFileRow = "_20-c";
export var viewButton = "_20-d";